import { captureException } from './logService';
import { rootStore } from '../mobx/rootStore';
import { cleanupWorkspaceListeners } from '../helpers/firebaseHelper';

/**
 * @desc load required data
 * @param {*}
 */
export const clearPreviousWorkspaceData = async () => {
  try {
    // Tear down workspace-scoped Firebase listeners (timer, project/view preferences,
    // message-sync trigger) before the stores are cleared and the next workspace's
    // listeners are created, so the previous workspace stops consuming reads immediately.
    cleanupWorkspaceListeners();
    rootStore.clearAllStores();
    return true;
  } catch (e) {
    captureException(e);
    return false;
  }
};
